import { acceptOnlyValidOptionByLabel } from '../../field-viewer/shared-normalizers';
export const challengesSingleChoiceViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByLabel
};

//# sourceMappingURL=definition-viewer.js.map